import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

class Title extends Component {
    static propTypes = {
        uri: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.fetch = this.fetch.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.uri !== this.props.uri) {
            this.fetch();
        }
    }

    async fetch() {
        const { uri } = this.props;

        const url = `/actions/seomatic/meta-container/meta-title-container/?uri=${uri}&asArray=true`;

        const response = await fetch(url);
        const meta = await response.json();

        this.setState({ ...meta });
    }

    render() {
        const { MetaTitleContainer = {} } = this.state;

        return (
            <Helmet>
                {MetaTitleContainer && MetaTitleContainer.title && (
                    <title>{MetaTitleContainer.title.title}</title>
                )}
            </Helmet>
        );
    }
}

export default Title;



// WEBPACK FOOTER //
// ./src/scripts/components/Title.js